import { graphqlApolloClient } from "../graphql-apollo-client"
import { GET_SUSTAINABILITY_DETAILS } from "./graphql/queries/getSustainabilityDetails"

export const getSustainabilityDetails = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: GET_SUSTAINABILITY_DETAILS,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.SustainabilityDetails
}